/* corex-textil-editor-sizing.js · Reglas de tamaño del personalizador de camisetas (sin DOM).
   - Escalar elementos sin deformarlos (cambia w o el tamaño de letra; el alto sale de la proporción), uno o varios
     como conjunto, con un ancla en su caja: 'top' (delante/detrás: el borde superior se queda a su distancia del
     cuello y crece hacia abajo y a los lados desde el centro horizontal), 'bottom' (mangas: el borde inferior se queda
     a su distancia del bajo y crece hacia arriba) o 'center'.
   - Tope: limitFactor busca el mayor factor permitido sin pasarse del pedido (el límite lo pone el editor:
     CorexTextilModel.sizeLimit, prenda en la talla de referencia y film).
   corners(capa) → esquinas giradas { x, y } (CorexTextilGeo.layerCorners). */
(function (global) {
  'use strict';

  var EPS = 0.001;  /* cm: el tope es el máximo exacto (el cobro tolera 0,05) */
  var SEARCH_STEPS = 24;

  function boxOf(points) {
    var xs = points.map(function (p) { return p.x; }), ys = points.map(function (p) { return p.y; });
    var b = { x0: Math.min.apply(null, xs), x1: Math.max.apply(null, xs), y0: Math.min.apply(null, ys), y1: Math.max.apply(null, ys) };
    return Object.assign(b, { w: b.x1 - b.x0, h: b.y1 - b.y0, cx: (b.x0 + b.x1) / 2, cy: (b.y0 + b.y1) / 2 });
  }
  /* Caja (sin ocultos) de las capas con esos ids, o null. */
  function boxOfIds(layers, ids, corners) {
    var pts = layers.filter(function (l) { return ids.indexOf(l.id) !== -1 && !l.hidden; })
      .reduce(function (acc, l) { return acc.concat(corners(l)); }, []);
    return pts.length ? boxOf(pts) : null;
  }
  /* ¿Cabe w×h en el tamaño (p. ej. '40x50') en alguna orientación? */
  function fits(w, h, size) {
    var p = String(size).split('x').map(Number);
    return (w <= p[0] + EPS && h <= p[1] + EPS) || (w <= p[1] + EPS && h <= p[0] + EPS);
  }
  /* Punto fijo del escalado en la caja b según el ancla. */
  function anchorPoint(b, anchor) {
    return { x: b.cx, y: anchor === 'top' ? b.y0 : anchor === 'bottom' ? b.y1 : b.cy };
  }
  /* Capas con las de ids escaladas por factor alrededor del ancla de su caja común (la de una sola capa, si es una).
     Cada capa escala su tamaño y su centro se acerca o aleja del ancla en la misma proporción, así que la caja entera
     escala alrededor del ancla. Imagen: w; texto: tamaño de letra. Nunca cambia la proporción. */
  function scaleLayers(layers, ids, factor, corners, anchor) {
    var b = boxOfIds(layers, ids, corners);
    if (!b) return layers;
    var p = anchorPoint(b, anchor);
    return layers.map(function (l) {
      if (ids.indexOf(l.id) === -1) return l;
      var patch = l.type === 'text' ? { size: l.size * factor } : { w: l.w * factor };
      patch.x = p.x + (l.x - p.x) * factor;
      patch.y = p.y + (l.y - p.y) * factor;
      return Object.assign({}, l, patch);
    });
  }
  /* Mayor factor ≤ wanted con ok(factor) cierto (ok es creciente: si un factor cabe, uno menor también).
     Reducir (≤ 1) siempre se permite. Devuelve { factor, limited }. */
  function limitFactor(ok, wanted) {
    if (wanted <= 1 || ok(wanted)) return { factor: wanted, limited: false };
    var lo = 1, hi = wanted;
    if (!ok(lo)) return { factor: 1, limited: true };
    for (var i = 0; i < SEARCH_STEPS; i++) {
      var mid = (lo + hi) / 2;
      if (ok(mid)) lo = mid; else hi = mid;
    }
    return { factor: lo, limited: true };
  }

  /* Mayor factor ≤ 1 con ok(factor) (para reducir lo que no cabe); 1 si ya cabe. */
  function shrinkFactor(ok) {
    if (ok(1)) return 1;
    var lo = 0, hi = 1;
    for (var i = 0; i < SEARCH_STEPS; i++) {
      var mid = (lo + hi) / 2;
      if (ok(mid)) lo = mid; else hi = mid;
    }
    return lo;
  }

  var api = { EPS: EPS, shrinkFactor: shrinkFactor, boxOf: boxOf, boxOfIds: boxOfIds, fits: fits, anchorPoint: anchorPoint, scaleLayers: scaleLayers, limitFactor: limitFactor };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.CorexTextilSizing = api;
})(this);
